import { render, staticRenderFns } from "./TyreLabels.vue?vue&type=template&id=6bdccf97&scoped=true"
import script from "./TyreLabels.vue?vue&type=script&lang=js"
export * from "./TyreLabels.vue?vue&type=script&lang=js"
import style0 from "./TyreLabels.vue?vue&type=style&index=0&id=6bdccf97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdccf97",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Ftyre-labels%2FTyreLabels.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports